<template>
    <div class="card" style="height:100%;padding-bottom:15px" v-loading='loading'>
        <div class="card-header">
            <h6 class="card-title tx-14 mg-b-0">Taxation</h6>
        </div><!-- card-header -->
            <div class="table-responsive mg-t-25">
                <table class="table table-striped table-talk-time">
                     <!-- <thead>
                        <tr>
                            <th>Year</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead> -->
                    <tbody v-show="isbgl===false">
                        <tr v-for='tax in taxs' :key='tax.tax_year'>
                            <td class='fy'>{{tax.tax_year+' FY'}}</td>
                            <td class="tx-right tx-medium tx-inverse">
                                <span v-show="tax.total_tax_refundable_or_payable">{{currentformats.AUformat(Math.abs(tax.total_tax_refundable_or_payable))}}</span>
                                <span v-show="!tax.total_tax_refundable_or_payable" style='color:#97a3b9'><small>N/A</small></span>
                            </td>
                            <td><span class="badge" :class='[tax.total_tax_refundable_or_payable>0?"badge-primary":"badge-secondary"]' style="color:white" v-show="tax.total_tax_refundable_or_payable">
                                {{tax.total_tax_refundable_or_payable>0?'Tax Refundable':'Amount Payable'}}</span>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-show="isbgl">
                        <tr v-for='tax in taxs' :key='tax.tax_year'>
                            <td>Last Tax Year Lodged</td>
                            <td>{{tax.tax_year}}</td>
                        </tr>
                    </tbody>
                </table>
            </div><!-- table-responsive -->
        </div><!-- card -->
</template>
<script>
import currentformats from '../../../utils/currentformats'
export default {
    name: 'taxation',
    components: {

    },
    data(){
        return{
            currentformats:currentformats,
            taxs:{},
            isbgl:false,
            loading:true
        }
    },
    created(){
        this.getCashData()
    },
    methods:{
        getCashData: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.isbgl = userdetail['isBGL'];
            this.$api.funddashboard_api.fundTax(this.$route.params.fund_code).then(response =>{
                this.taxs = response.data['taxs']
                this.loading = false
            });
        
        },
    }
}
</script>
<style scoped>
.fy{
    color: #7987a1;
    font-weight: 600;
    font-size: 11px;
    letter-spacing: .5px;
    text-transform: uppercase;
    padding-top:10px;
}
</style>